<script>
  import { onMount } from "svelte";
  import config from "../../config";
  // import basemap_config from '../../basemap-config';
  import layers from "../../layers";
  import {
    dev,
    lang,
    layers_visible,
    leaflet_layers,
    leaflet_map,
    panel_selected,
    plots,
    plot_selected,
    auth_logged_in
  } from "../store";
  import util from "../util";

  import "leaflet/dist/leaflet-src";
  import "leaflet/dist/leaflet.css";

  // https://www.npmjs.com/package/@geoman-io/leaflet-geoman-free
  import "@geoman-io/leaflet-geoman-free";
  import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

  // https://www.npmjs.com/package/leaflet-edgebuffer
  import "leaflet-edgebuffer";

  // https://www.npmjs.com/package/leaflet-geosearch
  import { OpenStreetMapProvider, SearchControl } from "leaflet-geosearch";
  import "leaflet-geosearch/dist/geosearch.css";

  // https://www.npmjs.com/package/leaflet-hash
  import "leaflet-hash";

  // https://www.npmjs.com/package/leaflet-mouse-position
  // import 'leaflet-mouse-position';
  // import 'leaflet-mouse-position/src/L.Control.MousePosition.css';

  // https://www.npmjs.com/package/leaflet.locatecontrol
  import "leaflet.locatecontrol";
  import "leaflet.locatecontrol/dist/L.Control.Locate.css";

  // https://www.npmjs.com/package/leaflet-measure-path
  import "leaflet-measure-path";
  import "leaflet-measure-path/leaflet-measure-path.css";

  import sync from '../sync';

  function activateEko4() {
    const urlHash = window.location.hash; 
    if (urlHash === '#eko4') {
      Object.keys($layers_visible).forEach(id => {
        if ($leaflet_map.hasLayer($leaflet_layers[id])) {
          $leaflet_map.removeLayer($leaflet_layers[id]);
        }
      });

      $layers_visible = {};

      if ('18_eko4_2024' in $leaflet_layers) {
        $leaflet_map.addLayer($leaflet_layers['18_eko4_2024']);
        $layers_visible['18_eko4_2024'] = 'on';
      }

      $layers_visible = { ...$layers_visible };
    }

    if ($auth_logged_in) {
      sync.update_user({layers: $layers_visible});
    }
  }

  function find_plot(input_str, check_type) {
    const is_equal = function (str1, str2) {
      return str1.toLowerCase() === str2;
    };
    const is_substring = function (str1, str2) {
      return str1.toLowerCase().includes(str2);
    };
    let compare_func;
    if (check_type === "equal") {
      compare_func = is_equal;
    } else if (check_type === "substring") {
      compare_func = is_substring;
    } else {
      console.error(`Unknown check_type ${check_type}`);
      return false;
    }
    const input_lower = input_str.toLowerCase();
    for (const [plot_id, plot] of Object.entries($plots)) {
      for (const param of config.search.plot_params) {
        if (plot[param] && compare_func(plot[param], input_lower)) {
          goto_plot(plot);
          return true;
        }
      }
    }
    return false;
  }

  function get_lat_long(coord_str, separator) {
    const coord_parts = coord_str.split(separator);
    if (coord_parts && coord_parts.length) {
      let coords = [];
      for (const coord_str of coord_parts) {
        if (config.search.regex_coord.test(coord_str.trim())) {
          coords.push(Number(coord_str.trim()));
        }
      }
      if (coords.length === 2) {
        let lat_long = {};
        if (coords[0] < coords[1]) {
          lat_long.lat = coords[1];
          lat_long.lng = coords[0];
        } else {
          lat_long.lat = coords[0];
          lat_long.lng = coords[1];
        }
        return lat_long;
      }
    }
    return "";
  }
  function goto_plot(plot) {
    $plot_selected = plot.plot_seq;
    let use_timeout = false;
    if (window.innerWidth < 800) {
      if ($panel_selected) {
        $panel_selected = "";
        use_timeout = true;
      }
    } else {
      if (!$panel_selected) {
        $panel_selected = "plots";
        use_timeout = true;
      }
    }
    if (use_timeout) {
      setTimeout(function () {
        $leaflet_map.fitBounds([
          [plot.extent.ymin, plot.extent.xmin],
          [plot.extent.ymax, plot.extent.xmax],
        ]);
      }, 100);
    } else {
      $leaflet_map.fitBounds([
        [plot.extent.ymin, plot.extent.xmin],
        [plot.extent.ymax, plot.extent.xmax],
      ]);
    }
  }
  function input_keypress(event) {
    if (event.key === "Enter") {
      search_go();
    } else if (event.key === "Escape") {
      search_reset();
    } else {
      input_invalid = false;
      // const input = search_parse_input(search_input.value.trim());
      // if (!input || input.type === 'invalid') {
      //   input_invalid = true;
      // } else {
      //   input_invalid = false;
      // }
    }
  }
  function search_focus() {
    if (window.innerWidth < 800) {
      $panel_selected = "";
    }
  }
  async function search_go() {
    search_input.readOnly = true;
    const input_value = search_input.value.trim();

    let found = false;
    if (!input_value) {
      // checking for empty value
      found = true;
    }
    if (!found) {
      // trying to search in existing plots
      // searching for precise value first
      found = find_plot(input_value, "equal");
      if (!found) {
        // then searching for a substring
        found = find_plot(input_value, "substring");
      }
    }
    if (!found) {
      // trying to search using external providers
      const input = search_parse_input(input_value);
      if (!input || input.type === "invalid") {
        found = false;
      } else if (input.type === "empty") {
        found = true;
      } else {
        if (dev) {
          console.log(input);
        }
        if (input.type === "address") {
          const results = await search_provider.search({
            query: input.value,
          });
          if (results && results.length && results[0].bounds) {
            $leaflet_map.fitBounds([
              [results[0].bounds[0][0], results[0].bounds[0][1]],
              [results[0].bounds[1][0], results[0].bounds[1][1]],
            ]);
            found = true;
          }
        } else if (input.type === "cadastre") {
          const lat_long = await util.search_cadastre(input.value);
          if (lat_long) {
            $leaflet_map.setView(lat_long, config.search.default_zoom);
            found = true;
          }
        } else if (input.type === "coords") {
          $leaflet_map.setView(input.value, config.search.default_zoom);
          found = true;
        } else if (input.type === "lad_block") {
          let extent = await util.search_lad_block(input.value);
          if (extent) {
            $leaflet_map.fitBounds(extent);
            found = true;
          }
        } else {
          console.error(`Unknown input type ${input.type}`);
        }
      }
    }
    if (found) {
      search_input.value = "";
      input_invalid = false;
    } else {
      input_invalid = true;
    }
    search_input.readOnly = false;
  }
  function search_parse_input(input_value) {
    if (!input_value) {
      return { type: "empty", value: "" };
    } else if (config.search.regex_lad_block.test(input_value)) {
      return { type: "lad_block", value: input_value };
    } else if (config.search.regex_cadastre1.test(input_value)) {
      const cad_nr = input_value.replace(/\s/g, "");
      if (config.search.regex_cadastre2.test(cad_nr)) {
        return { type: "cadastre", value: cad_nr };
      }
    } else if (config.search.regex_coords1.test(input_value)) {
      const coord_str = input_value.replace(/\,/g, ".");
      const lat_long = get_lat_long(coord_str, " ");
      if (lat_long) {
        return { type: "coords", value: lat_long };
      }
    } else if (config.search.regex_coords2.test(input_value)) {
      const lat_long = get_lat_long(input_value, ",");
      if (lat_long) {
        return { type: "coords", value: lat_long };
      }
    } else if (config.search.regex_address.test(input_value)) {
      return { type: "address", value: input_value };
    }
    return { type: "invalid", value: "" };
  }
  function search_reset() {
    search_input.value = "";
    input_invalid = false;
  }

  function go_prev() {
    let go_index = dates.indexOf(date_selected) + 1;
    if (go_index < dates.length) {
      date_selected = dates[go_index];
      update_basemap();
    }
  }

  function go_next() {
    let go_index = dates.indexOf(date_selected) - 1;
    if (go_index >= 0) {
      date_selected = dates[go_index];
      update_basemap();
    }
  }

  function update_basemap(event) {
    for (let layer_id of ["89_s2_meta", "90_s2_rgb"]) {
      const visible = $layers_visible[layer_id];
      if (visible) {
        if ($leaflet_map.hasLayer($leaflet_layers[layer_id])) {
          $leaflet_map.removeLayer($leaflet_layers[layer_id]);
        }
      }
      $layers_visible[layer_id] = "on";
      const layer_obj = util.add_layer(
        layer_id,
        layers[layer_id],
        $leaflet_map,
        true,
        layer_type,
        date_selected
      );
      $leaflet_layers[layer_id] = layer_obj;
    }
  }

  function getISOWeek(date_orig) {
    let date = new Date(date_orig);
    // ISO week date weeks start on Monday, so correct the day number
    const n_day = (date.getDay() + 6) % 7;

    // ISO 8601 states that week 1 is the week with the first Thursday of that year
    // Set the target date to the Thursday in the target week
    date.setDate(date.getDate() - n_day + 3);

    // Store the millisecond value of the target date
    const thursday_millis = date.valueOf();

    // Set the target to the first Thursday of the year
    // First, set the target to January 1st
    date.setMonth(0, 1);

    // Not a Thursday? Correct the date to the next Thursday
    if (date.getDay() !== 4) {
      date.setMonth(0, 1 + ((4 - date.getDay() + 7) % 7));
    }

    // The week number is the number of weeks between the first Thursday of the year
    // and the Thursday in the target week (604800000 = 7 * 24 * 3600 * 1000)
    const week = 1 + Math.ceil((thursday_millis - date) / 604800000);
    let year = date.getFullYear();
    if (date.getMonth() === 0 && week > 50) {
      year -= 1;
    }
    if (week < 10) {
      return `${year}-W0${week}`;
    } else {
      return `${year}-W${week}`;
    }
  }

  onMount(async () => {
    // let L = window.L;
    let map = L.map("map", {
      attributionControl: false,
      center: [57.0, 24.7],
      zoom: 7,
      zoomControl: false,
    });
    $leaflet_map = map;

    map.createPane("basemapPane");
    map.getPane("basemapPane").style.zIndex = 100;

    let grayBasemapLayer = L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${config.basemap.carto_key}`,
      {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
        pane: "basemapPane",
        tileSize: 512,
        zoomOffset: -1,
      }
    );
    grayBasemapLayer.addTo(map);

    // controls
    let attrib = L.control
      .attribution({
        position: "bottomright",
        prefix:
          '<a href="https://smartagro.lv/">SmartAgro</a>, <a href="https://nominatim.org/">Geocoding by Nominatim</a>',
      })
      .addTo(map);

    let zoom = L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);

    // https://www.npmjs.com/package/leaflet-geosearch
    search_provider = new OpenStreetMapProvider({
      params: {
        email: "info@forestradar.com", // auth for large number of requests
        addressdetails: 0, // include additional address detail parts
        countrycodes: "lv", // limit search results to specific countries
      },
    });

    // https://www.npmjs.com/package/leaflet-hash
    //let hash = new L.Hash(map);

    // https://www.npmjs.com/package/leaflet-mouse-position
    // L.control.mousePosition({
    //   numDigits: 5,
    //   position: 'bottomleft',
    //   prefix: 'Lat/long: ',
    //   separator: ',',
    // }).addTo(map);

    L.control
      .scale({
        imperial: false,
        position: "bottomleft",
      })
      .addTo(map);

    // https://www.npmjs.com/package/leaflet.locatecontrol
    const locate = L.control.locate({
      locateOptions: { enableHighAccuracy: true },
      position: "topright",
      showPopup: false,
    });
    locate.addTo(map);

    // https://www.npmjs.com/package/@geoman-io/leaflet-geoman-free
    map.pm.addControls(config.geoman.measure_controls);
    map.on("pm:create", (event) => {
      event.layer.showMeasurements({
        formatArea: function (value) {
          value = value / 10000;
          return `${value.toFixed(2)} ha`;
        },
      });
    });

    await util.add_layers();

    setTimeout(() => {
        activateEko4();
    }, 500); // Wait for layer items to fully load

  });

  let input_invalid = false;
  let search_input;
  let search_provider;
  let layer_type = "rgb";

  let weeks = {};
  const start_date = new Date(Date.UTC(2017, 4 - 1, 24)); // 2017-04-24, months are zero-indexed
  const now = new Date();
  const end_date = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
  );
  let curr_date = start_date;
  let week;
  let week_start;
  let week_end;
  do {
    week = getISOWeek(curr_date);
    week_start = curr_date.toISOString().slice(0, 10);
    curr_date.setDate(curr_date.getDate() + 6);
    week_end = curr_date.toISOString().slice(0, 10);
    weeks[week] = `${week_start} - ${week_end}`;
    curr_date.setDate(curr_date.getDate() + 1);
    // console.log(`${week}: ${week_start}, ${week_end}`);
  } while (curr_date <= end_date);
  weeks["latest"] = "Pēdējie aktuālie dati";

  let dates = Object.keys(weeks);
  dates.reverse();
  let date_selected = dates[0];
  const legend_labels = {
    "fapar-elong": [-0.1, 0.4, 0.9],
    "fapar-till": [-0.1, 0.4, 0.9],
    "fcover-elong": [-0.1, 0.4, 0.9],
    "fcover-till": [-0.1, 0.4, 0.9],
    "lai-elong": [-0.1, 1.45, 2.9],
    "lai-till": [-0.1, 1.45, 2.9],
    lai: [-0.1, 1.45, 2.9],
    fapar: [-0.1, 0.35, 0.8],
    fcover: [-0.1, 0.35, 0.8],
    msavi2: [-0.1, 0.4, 0.9],
    ndvi: [-0.1, 0.4, 0.9],
    ndwi: [-0.1, 0.35, 0.8],
  };
</script>

<section>
  <div class="map-controls-top">
    <div class="search">
      <input
        autocomplete="street-address"
        autocorrect="off"
        bind:this={search_input}
        class:input_invalid
        maxlength="50"
        on:focus={search_focus}
        on:keyup={input_keypress}
        spellcheck="false"
        type="text"
        placeholder={util.caption($lang, "search", "placeholder")}
        size="39"
      />
      <p class="reset-search" on:click={search_reset}>×</p>
    </div>
  </div>
  <div class="map-controls-bottom">
    <div class="layer-type">
      <p>Satelītkartes veids</p>
      <div class="filler"></div>
      <select
        class="layer-type-select"
        bind:value={layer_type}
        on:change={update_basemap}
        required
      >
        <option value="rgb">Krāsainā karte</option>
        <option value="nir-r-g">Infrasarkanā karte (NIR-R-G)</option>
        <option value="nir-g-b">Infrasarkanā karte (NIR-G-B)</option>
        <option value="swir">Infrasarkanā karte (SWIR)</option>
        <option value="ndvi">Vispārīgs veģetācijas indekss (NDVI)</option>
        <option value="msavi2">Vispārīgs veģetācijas indekss (MSAVI2)</option>
        <option value="fapar"
          >Veģetācijas indekss ziemas kviešiem (FAPAR)</option
        >
        <option value="fcover"
          >Veģetācijas indekss ziemas kviešiem (FCover)</option
        >
        <option value="lai">Veģetācijas indekss ziemas kviešiem (LAI)</option>
        <option value="ndwi">Zemes mitruma indekss (NDWI)</option>
      </select>
    </div>
    <div class="date">
      <p>Datums</p>
      <div class="filler"></div>
      <button class="go" on:click={go_prev}>←</button>
      <select
        class="date-select"
        bind:value={date_selected}
        on:change={update_basemap}
        required
      >
        {#each dates as date}
          <option value={date}>{weeks[date]}</option>
        {/each}
      </select>
      <!-- <input type="date" class='date-select' on:change={update_basemap} min={dates[0]} max={dates[dates.length-1]} required bind:value={date_selected}> -->
      <button class="go" on:click={go_next}>→</button>
    </div>
    <div class="legend">
      <p>Apzīmējumi</p>
      <div class="filler"></div>
      {#if legend_labels.hasOwnProperty(layer_type)}
        <div class="legend-img">
          <div class="vertical">
            <img src="legend.png" width="100%" height="100%" />
            <div class="horizontal">
              <p class="legend-label">{legend_labels[layer_type][0]}</p>
              <div class="filler"></div>
              <p class="legend-label">{legend_labels[layer_type][1]}</p>
              <div class="filler"></div>
              <p class="legend-label">{legend_labels[layer_type][2]}</p>
            </div>
          </div>
        </div>
      {:else}
        <p><i>Neattiecās</i></p>
        <div class="filler"></div>
      {/if}
    </div>
  </div>
  <div class="map" id="map"></div>
</section>

<style>
  section {
    background-color: #ddd;
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
  }
  input {
    box-shadow: none;
    flex: 1 1 auto;
    font-size: 0.9em;
    margin: 0.1em;
    padding: 0.35em 0.4em 0.35em 0.8em; /* top | right | bottom | left */
    width: 100%;
  }
  input:focus {
    outline-color: #aaa;
  }
  .map-controls-top {
    align-self: center;
    display: flex;
    flex-flow: column;
    margin: 10px 55px 10px 55px; /* top | right | bottom | left */
    pointer-events: none;
    position: absolute;
  }
  .map-controls-bottom {
    /*align-self: ;*/
    /*margin: 10px 10px 10px 10px;  top | right | bottom | left  */
    bottom: 0;
    display: flex;
    flex-flow: column;
    pointer-events: none;
    position: absolute;
    right: 0;
    margin: 10px 10px 10px 10px; /* top | right | bottom | left */
  }
  .search {
    background-clip: padding-box;
    background-color: #fff;
    border-radius: 4px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    display: flex;
    flex-flow: row;
    pointer-events: auto;
    z-index: 1000;
  }
  .reset-search {
    cursor: pointer;
    flex: 0 0 auto;
    font-size: 0.9em;
    margin: 0.1em;
    padding: 0.35em;
  }
  .input_invalid {
    background-color: #fcc;
  }
  .map {
    flex: 1 1 auto;
  }
  @media screen and (max-width: 550px) {
    .map-controls {
      margin: 10px 55px 10px 10px; /* top | right | bottom | left */
      width: calc(100% - 65px);
    }
  }
  .date {
    pointer-events: auto;
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    /*align-self: flex-end;*/
    background-color: #ffec;
    border-radius: 0.2em;
    margin: 0 0em 0.2em 0.4em; /* top | right | bottom | left */
    width: 100%;
    z-index: 1000;
  }
  .date-select {
    font-size: 1em;
    height: 1.6em;
    padding: 0.2em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
    width: 14em;
  }
  .layer-type {
    pointer-events: auto;
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    /*align-self: flex-end;*/
    background-color: #ffec;
    border-radius: 0.2em;
    margin: 0 0em 0.2em 0.4em; /* top | right | bottom | left */
    width: 100%;
    z-index: 1000;
  }
  .layer-type-select {
    font-size: 1em;
    height: 1.6em;
    padding: 0.2em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
    width: 14em;
  }
  .legend {
    pointer-events: auto;
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    /*align-self: flex-end;*/
    background-color: #ffec;
    border-radius: 0.2em;
    margin: 0 0em 0.8em 0.4em; /* top | right | bottom | left */
    width: 100%;
    z-index: 1000;
  }
  .legend-img {
    align-self: center;
    margin-right: 0.3em;
    width: 14em;
  }
  .legend-label {
    font-size: 0.8em;
    padding: 0em;
    margin: 0em;
  }
  .filler {
    flex: 1 1 auto;
  }
  .go {
    font-size: 1em;
    height: 1.6em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
    padding: 0 0.4em 0 0.4em; /* top | right | bottom | left */
  }
  .horizontal {
    display: flex;
    flex-flow: row;
  }
  .vertical {
    display: flex;
    flex-flow: column;
  }
</style>
